module.exports = __webpack_public_path__ + "img/eye-cross.795343ab.svg";